import { defineMessages } from 'react-intl';

const errorCode: { [key: string]: any } = defineMessages({
  // 400000为通用错误码，与后端讨论后，这里暂时先注释
  // 400000: {
  //   id: 'There is no plan to fit your quote, please check the correctness of each field',
  // },
  400016: { id: 'The vehicle is too old to be insured' },
  400017: { id: 'The vehicle age is invalid to be insured' },
  400018: { id: 'The vehicle usage is unsupported to be insured' },
  400019: { id: 'The vehicle catagory is unsupported to be insured' },
  400020: { id: 'The vehicle price is unsupported to be insured' },
  400021: { id: 'The vehicle series is unsupported to be insured' },
  400022: { id: 'The vehicle manufacture year is unsupported to be insured' },
  400200: { id: 'Sorry, you can only add one "self" in the insured list' },
  400202: {
    id: 'The age of the insured person should be from 5 to 65 years old',
  },
  400204: {
    id: 'Insured from 05 to 17 years old must take policy with their parents',
  },
  400205: {
    id: 'Insured from 05 to 17 years old must take policy with their parents',
  },
});

export default errorCode;
